(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lcw-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  /* LCW Hero Slideshow — comportamento (Lucrow / LCW) */
  class LcwHeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-lcw-track]');
      this.viewport = this.querySelector('.lcw-hero__viewport');
      this.slides = Array.from(this.querySelectorAll('[data-lcw-slide]'));
      if (!this.track || this.slides.length === 0) return;

      this.index = 0;
      this.prevBtn = this.querySelector('.lcw-hero__arrow--prev');
      this.nextBtn = this.querySelector('.lcw-hero__arrow--next');
      this.dotsWrap = this.querySelector('.lcw-hero__dots');
      this.dots = Array.from(this.querySelectorAll('[data-lcw-dot]'));

      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.timer = null;
      this.paused = false;
      this.dragging = false;
      this.moved = false;
      this.startX = 0;
      this.curX = 0;
      this.threshold = 40;
      this.resizeRaf = null;
      this.ac = new AbortController();
      this.single = this.slides.length <= 1;

      this.gaEnabled = this.dataset.ga === 'true';
      this.gaMethod = this.dataset.gaMethod || 'pixel';
      this.gaLocation = this.dataset.gaLocation || 'home_hero';
      this.viewed = new Set();
      this.inView = false;

      if (!this.single) {
        if (this.prevBtn) this.prevBtn.hidden = false;
        if (this.nextBtn) this.nextBtn.hidden = false;
        if (this.dotsWrap) this.dotsWrap.hidden = false;
        this.bindControls();
        this.bindDrag();
        this.bindKeys();
        this.bindAutoplayGuards();
      }
      this.bindEditorEvents();
      this.bindHeightWatchers();
      this.bindTracking();

      this.goTo(0, false);
      if (this.autoplay && !this.single && !this.reduceMotion) this.start();
    }

    bindControls() {
      const sig = { signal: this.ac.signal };
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.prev(); this.restart(); }, sig);
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.next(); this.restart(); }, sig);
      this.dots.forEach((d) => {
        d.addEventListener('click', () => { this.goTo(parseInt(d.dataset.lcwDot, 10)); this.restart(); }, sig);
      });
    }

    bindKeys() {
      if (!this.hasAttribute('tabindex')) this.tabIndex = 0;
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { this.prev(); this.restart(); }
        else if (e.key === 'ArrowRight') { this.next(); this.restart(); }
      }, { signal: this.ac.signal });
    }

    bindDrag() {
      const vp = this.viewport;
      const sig = { signal: this.ac.signal };
      vp.addEventListener('touchstart', (e) => this.dragStart(e.touches[0].clientX), { passive: true, signal: this.ac.signal });
      vp.addEventListener('touchmove', (e) => this.dragMove(e.touches[0].clientX), { passive: true, signal: this.ac.signal });
      vp.addEventListener('touchend', () => this.dragEnd(), sig);
      vp.addEventListener('mousedown', (e) => { this.dragStart(e.clientX); e.preventDefault(); }, sig);
      window.addEventListener('mousemove', (e) => { if (this.dragging) this.dragMove(e.clientX); }, sig);
      window.addEventListener('mouseup', () => { if (this.dragging) this.dragEnd(); }, sig);
      vp.addEventListener('click', (e) => {
        if (this.moved) { e.preventDefault(); e.stopPropagation(); this.moved = false; }
      }, { capture: true, signal: this.ac.signal });
    }

    dragStart(x) {
      this.dragging = true; this.moved = false;
      this.startX = x; this.curX = x;
      this.track.style.transition = 'none';
      this.stop();
    }
    dragMove(x) {
      if (!this.dragging) return;
      this.curX = x;
      const diff = x - this.startX;
      if (Math.abs(diff) > 5) this.moved = true;
      this.track.style.transform = `translateX(calc(${-this.index * 100}% + ${diff}px))`;
    }
    dragEnd() {
      if (!this.dragging) return;
      this.dragging = false;
      this.track.style.transition = '';
      const diff = this.curX - this.startX;
      if (diff < -this.threshold) this.next();
      else if (diff > this.threshold) this.prev();
      else this.goTo(this.index);
      this.restart();
    }

    goTo(i, animate = true) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      if (!animate) this.track.style.transition = 'none';
      this.track.style.transform = `translateX(${-this.index * 100}%)`;
      if (!animate) { void this.track.offsetHeight; this.track.style.transition = ''; }

      this.dots.forEach((d, di) => {
        const active = di === this.index;
        d.classList.toggle('is-active', active);
        if (active) d.setAttribute('aria-selected', 'true');
        else d.removeAttribute('aria-selected');
      });

      this.adaptHeight();
      this.applyA11y();
      this.playActiveVideo();
      this.trackView(this.index);
    }
    next() { this.goTo(this.index + 1); }
    prev() { this.goTo(this.index - 1); }

    /* Altura adaptativa: o viewport assume a altura do slide ativo */
    adaptHeight() {
      const active = this.slides[this.index];
      if (!active) return;
      const h = active.offsetHeight;
      if (h > 0) this.viewport.style.height = h + 'px';
    }

    bindHeightWatchers() {
      const sig = { signal: this.ac.signal };
      // Recalcula quando cada mídia carrega (caso falte width/height intrínseco)
      this.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => this.adaptHeight(), sig);
      });
      this.querySelectorAll('video').forEach((v) => {
        v.addEventListener('loadedmetadata', () => this.adaptHeight(), sig);
      });
      // Recalcula no resize (inclui troca desktop/mobile)
      window.addEventListener('resize', () => {
        if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf);
        this.resizeRaf = requestAnimationFrame(() => this.adaptHeight());
      }, sig);
    }

    applyA11y() {
      this.slides.forEach((s, si) => {
        const inactive = si !== this.index;
        s.setAttribute('aria-hidden', inactive ? 'true' : 'false');
        s.querySelectorAll('a, button, video').forEach((f) => { f.tabIndex = inactive ? -1 : 0; });
      });
    }

    playActiveVideo() {
      this.slides.forEach((s, si) => {
        s.querySelectorAll('video').forEach((v) => {
          const visible = v.offsetParent !== null;
          if (si === this.index && visible) {
            const p = v.play();
            if (p && p.catch) p.catch(() => {});
          } else {
            v.pause();
          }
        });
      });
    }

    bindAutoplayGuards() {
      if (!this.autoplay || this.reduceMotion) return;
      const sig = { signal: this.ac.signal };
      this.addEventListener('mouseenter', () => { this.paused = true; this.stop(); }, sig);
      this.addEventListener('mouseleave', () => { this.paused = false; this.start(); }, sig);
      this.addEventListener('focusin', () => { this.paused = true; this.stop(); }, sig);
      this.addEventListener('focusout', () => { this.paused = false; this.start(); }, sig);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else if (!this.paused) this.start();
      }, sig);
    }

    bindEditorEvents() {
      if (!window.Shopify || !window.Shopify.designMode) return;
      const sig = { signal: this.ac.signal };
      document.addEventListener('shopify:block:select', (e) => {
        if (!this.contains(e.target)) return;
        const slide = e.target.closest('[data-lcw-slide]');
        const i = this.slides.indexOf(slide);
        if (i >= 0) { this.stop(); this.goTo(i); }
      }, sig);
      document.addEventListener('shopify:block:deselect', (e) => {
        if (!this.contains(e.target)) return;
        this.restart();
      }, sig);
    }

    /* ---------- Tracking GA4 (promoção interna) ---------- */
    bindTracking() {
      if (!this.gaEnabled) return;
      if (window.Shopify && window.Shopify.designMode) return; // não polui dados no editor
      const sig = { signal: this.ac.signal };

      // Cliques -> select_promotion
      this.slides.forEach((s, i) => {
        const link = s.querySelector('a.lcw-hero__link');
        if (link) {
          link.addEventListener('click', () => {
            if (this.moved) return; // ignora clique após arrasto
            this.trackPromotion('select_promotion', s, i);
          }, sig);
        }
      });

      // Impressões -> view_promotion (só quando o carrossel está visível)
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            this.inView = e.isIntersecting;
            if (e.isIntersecting) this.trackView(this.index);
          });
        }, { threshold: 0.5 });
        this.io.observe(this);
      } else {
        this.inView = true;
        this.trackView(this.index);
      }
    }

    trackView(i) {
      if (!this.gaEnabled || !this.inView) return;
      if (this.viewed.has(i)) return; // 1 impressão por slide por pageview
      this.viewed.add(i);
      this.trackPromotion('view_promotion', this.slides[i], i);
    }

    trackPromotion(eventName, slide, i) {
      if (!this.gaEnabled || !slide) return;
      const name = slide.dataset.promoName || slide.dataset.promoCreative || ('Slide ' + (i + 1));
      const creative = slide.dataset.promoCreative || '';
      const slot = this.gaLocation + '_' + (i + 1);
      const id = (slide.dataset.promoName || slot)
        .toString().trim().toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '') || slot;

      const item = { promotion_id: id, promotion_name: name, creative_slot: slot, location_id: this.gaLocation };
      if (creative) item.creative_name = creative;
      const payload = { promotion_id: id, promotion_name: name, creative_slot: slot, location_id: this.gaLocation, items: [item] };

      // Web Pixel (Customer Events) — recomendado
      if (this.gaMethod === 'pixel') {
        try {
          if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish('lcw_' + eventName, payload);
          }
        } catch (e) {}
      }
      // GTM no tema (dataLayer)
      if (this.gaMethod === 'gtm' && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({ event: eventName, ecommerce: { items: [item] } });
      }
      // gtag no tema (GA4 direto)
      if (this.gaMethod === 'gtag' && typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
      }
    }

    start() {
      this.stop();
      if (this.single || this.reduceMotion || !this.autoplay) return;
      this.timer = setInterval(() => this.next(), this.speed);
    }
    stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    restart() { if (!this.paused) this.start(); }

    disconnectedCallback() {
      this.stop();
      if (this.io) this.io.disconnect();
      if (this.ac) this.ac.abort();
    }
  }

  if (!customElements.get('lcw-hero-slideshow')) {
    customElements.define('lcw-hero-slideshow', LcwHeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcw-shoppable-video"] && !Shopify.designMode) return;
  try {
    
  class LcwShoppableVideo extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.lcw-svideo__track');
      this.prevBtn = this.querySelector('[data-direction="prev"]');
      this.nextBtn = this.querySelector('[data-direction="next"]');
      this.trackingOn = this.dataset.tracking === 'true';
      this.autoplayOn = this.dataset.autoplay === 'true';
      this.listId = this.dataset.listId || 'lcw_shoppable_video';

      this.bindArrows();
      this.bindSlides();
      this.setupCarouselAutoplay();
      this.updateArrows();
      this.track && this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows(), { passive: true });
    }

    bindArrows() {
      [this.prevBtn, this.nextBtn].forEach((btn) => {
        if (!btn) return;
        btn.addEventListener('click', () => {
          const dir = btn.dataset.direction === 'next' ? 1 : -1;
          this.track.scrollBy({ left: dir * this.track.clientWidth * 0.9, behavior: 'smooth' });
        });
      });
    }

    updateArrows() {
      if (!this.track || !this.prevBtn || !this.nextBtn) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      this.prevBtn.toggleAttribute('disabled', scrollLeft <= 1);
      this.nextBtn.toggleAttribute('disabled', scrollLeft >= scrollWidth - clientWidth - 1);
    }

    setupCarouselAutoplay() {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.autoplayOn || reduce) return;
      const vids = this.querySelectorAll('.lcw-svideo__cvideo');
      if (!vids.length || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          const v = e.target;
          if (e.isIntersecting) { v.muted = true; v.play().catch(() => {}); } else { v.pause(); }
        });
      }, { threshold: 0.5 });
      vids.forEach((v) => io.observe(v));
    }

    bindSlides() {
      const slides = Array.from(this.querySelectorAll('.lcw-svideo__slide'));
      slides.forEach((slide, idx) => {
        const trigger = slide.querySelector('.lcw-svideo__trigger');
        const dialog = slide.querySelector('.lcw-svideo__modal');
        if (!trigger || !dialog) return;
        const video = dialog.querySelector('.lcw-svideo__modal-video video');
        const aside = dialog.querySelector('.lcw-svideo__modal-aside');

        trigger.addEventListener('click', () => this.openModal(dialog, video, slide));
        dialog.querySelector('.lcw-svideo__close')?.addEventListener('click', () => this.closeModal(dialog, video));
        dialog.addEventListener('click', (e) => { if (e.target === dialog) this.closeModal(dialog, video); });
        dialog.addEventListener('close', () => { if (video) video.pause(); });

        // navegação entre vídeos
        const prevNav = dialog.querySelector('[data-modal-nav="prev"]');
        const nextNav = dialog.querySelector('[data-modal-nav="next"]');
        if (slides.length <= 1) {
          prevNav && (prevNav.hidden = true);
          nextNav && (nextNav.hidden = true);
        } else {
          prevNav?.addEventListener('click', () => this.gotoSlide(slides, idx, -1));
          nextNav?.addEventListener('click', () => this.gotoSlide(slides, idx, 1));

          // swipe horizontal na área do vídeo (touch)
          const videoWrap = dialog.querySelector('.lcw-svideo__modal-video');
          if (videoWrap) {
            let startX = 0, startY = 0, tracking = false;
            videoWrap.addEventListener('touchstart', (e) => {
              const t = e.changedTouches[0];
              startX = t.clientX; startY = t.clientY; tracking = true;
            }, { passive: true });
            videoWrap.addEventListener('touchend', (e) => {
              if (!tracking) return;
              tracking = false;
              const t = e.changedTouches[0];
              const dx = t.clientX - startX;
              const dy = t.clientY - startY;
              if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
                this.gotoSlide(slides, idx, dx < 0 ? 1 : -1);
              }
            }, { passive: true });
          }
        }

        dialog.querySelector('[data-action="playpause"]')?.addEventListener('click', () => {
          if (!video) return;
          video.paused ? video.play() : video.pause();
        });
        dialog.querySelector('[data-action="mute"]')?.addEventListener('click', () => {
          if (!video) return;
          video.muted = !video.muted;
          dialog.classList.toggle('is-muted', video.muted);
        });
        if (video) {
          video.addEventListener('play', () => dialog.classList.add('is-playing'));
          video.addEventListener('pause', () => dialog.classList.remove('is-playing'));
          this.bindTimeline(dialog, video);
        }

        dialog.querySelectorAll('[data-buy]').forEach((btn) => {
          btn.addEventListener('click', () => { this.openDetail(aside, btn.dataset.buy); this.trackSelect(dialog, btn.dataset.buy); });
        });
        dialog.querySelectorAll('.lcw-svideo__back').forEach((b) => b.addEventListener('click', () => this.closeDetail(aside)));
        dialog.querySelectorAll('.lcw-svideo__atc-form form').forEach((form) => {
          form.addEventListener('submit', () => {
            const d = form.closest('.lcw-svideo__detail');
            if (d) this.trackAddToCart(dialog, d.dataset.detailId);
          });
        });
      });
    }

    bindTimeline(dialog, video) {
      const timeline = dialog.querySelector('.lcw-svideo__timeline');
      const fill = dialog.querySelector('.lcw-svideo__timeline-fill');
      if (!timeline || !fill) return;
      video.addEventListener('timeupdate', () => {
        fill.style.width = (video.duration ? (video.currentTime / video.duration) * 100 : 0) + '%';
      });
      const seek = (clientX) => {
        const rect = timeline.getBoundingClientRect();
        const ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
        if (video.duration) video.currentTime = ratio * video.duration;
      };
      timeline.addEventListener('click', (e) => seek(e.clientX));
    }

    openModal(dialog, video, slide) {
      dialog.showModal();
      if (video) {
        video.muted = false;
        dialog.classList.remove('is-muted');
        video.play().then(() => dialog.classList.add('is-playing')).catch(() => {
          video.muted = true; dialog.classList.add('is-muted'); video.play().catch(() => {});
        });
      }
      this.trackViewList(slide);
    }

    closeModal(dialog, video) {
      if (video) video.pause();
      this.closeDetail(dialog.querySelector('.lcw-svideo__modal-aside'));
      dialog.close();
    }

    gotoSlide(slides, idx, dir) {
      const cur = slides[idx];
      const curDialog = cur.querySelector('.lcw-svideo__modal');
      const curVideo = curDialog.querySelector('.lcw-svideo__modal-video video');
      const n = (idx + dir + slides.length) % slides.length;
      const nx = slides[n];
      const nxDialog = nx.querySelector('.lcw-svideo__modal');
      const nxVideo = nxDialog.querySelector('.lcw-svideo__modal-video video');
      this.closeModal(curDialog, curVideo);
      requestAnimationFrame(() => this.openModal(nxDialog, nxVideo, nx));
    }

    openDetail(aside, productId) {
      aside.querySelectorAll('.lcw-svideo__detail').forEach((d) => {
        d.classList.toggle('lcw-svideo__detail--active', d.dataset.detailId === productId);
      });
      aside.classList.add('is-detail');
    }
    closeDetail(aside) {
      if (!aside) return;
      aside.classList.remove('is-detail');
      aside.querySelectorAll('.lcw-svideo__detail--active').forEach((d) => d.classList.remove('lcw-svideo__detail--active'));
    }

    push(event) {
      if (!this.trackingOn) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(event);
      if (typeof window.gtag === 'function') window.gtag('event', event.event, event.ecommerce || {});
    }
    itemsFrom(slide) {
      return Array.from(slide.querySelectorAll('[data-product-id]')).map((el, i) => ({
        item_id: el.dataset.productId, item_name: el.dataset.productTitle,
        price: parseFloat(el.dataset.productPrice) || undefined, index: i,
        item_list_id: this.listId, item_list_name: 'LCW Shoppable Video',
      }));
    }
    productData(dialog, productId) {
      const el = dialog.querySelector('[data-product-id="' + productId + '"]');
      if (!el) return {};
      return { item_id: el.dataset.productId, item_name: el.dataset.productTitle, price: parseFloat(el.dataset.productPrice) || undefined, item_list_id: this.listId };
    }
    trackViewList(slide) { this.push({ event: 'view_item_list', ecommerce: { item_list_id: this.listId, item_list_name: 'LCW Shoppable Video', items: this.itemsFrom(slide) } }); }
    trackSelect(dialog, productId) { this.push({ event: 'select_item', ecommerce: { item_list_id: this.listId, items: [this.productData(dialog, productId)] } }); }
    trackAddToCart(dialog, productId) {
      const item = this.productData(dialog, productId);
      this.push({ event: 'add_to_cart', ecommerce: { currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : undefined, value: item.price, items: [item] } });
    }
  }
  if (!customElements.get('lcw-shoppable-video')) customElements.define('lcw-shoppable-video', LcwShoppableVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
